import Icon from '../Icon.vue'

Icon.register({
  'spotify': {
    width: 16,
    height: 16,
    paths: [
      {
        d: 'M7.9995 0C3.5814 0 0 3.5814 0 7.9995c0 4.4182 3.5814 7.9995 7.9995 7.9995 4.4182 0 7.9995-3.5813 7.9995-7.9995C16 3.5814 12.4177 0 7.9995 0Zm3.6693 11.5388a.4987.4987 0 0 1-.6859.1663c-1.879-1.1483-4.2434-1.4072-7.028-.771a.4981.4981 0 1 1-.2216-.9715c3.0473-.6964 5.661-.3964 7.7702.8913.235.1423.3085.4499.1653.6849Zm.9791-2.179c-.1805.2933-.5646.386-.8578.2054-2.1494-1.3211-5.428-1.7042-7.9718-.9323-.3296.0993-.6783-.086-.7786-.4156a.6247.6247 0 0 1 .4156-.7776c2.906-.8817 6.5178-.4547 8.9863 1.0633.2942.1805.3859.5645.2063.8568Zm.0841-2.2678c-2.5783-1.5313-6.8322-1.6717-9.294-.9247-.3954.1204-.8129-.1032-.9333-.4987a.7488.7488 0 0 1 .4987-.9333c2.8257-.8578 7.5238-.6916 10.4919 1.07.3553.211.4719.6706.2617 1.025-.2111.3553-.6706.4728-1.025.2617Z'
      }
    ]
  }
})
